import { DateRange } from 'moment-range';
import { DashboardDateRange } from '../../util/DashboardDateRange';

/**
 * This function is here to check there is data available for a given DateRange
 *
 * @param range The DateRange to check if there is data for.
 * @param dataAvailableDates the DateRanges that data is available for
 * @return [boolean] True if there is
 */
export const isDataAvailableForDateRange = (range: DashboardDateRange, dataAvailableDates: DateRange[]): boolean => {
  // Find any available date ranges that have a full overlap with [range]
  const overlappingRanges = dataAvailableDates.filter(r => r.overlaps(range.getMomentDateRange()));
  // Are there any?
  return !!overlappingRanges.length;
};
